module.exports = function getResource(label) {
    let resources = {
        sortBy: 'Trier par'
    };

    return resources[label];
};
